export default function SegmentedYesNo({ value, onChange, error, name }) {
  const isYes = value === true
  const isNo = value === false
  const errCls = error ? ' has-error' : ''

  return (
    <div className="segmented-yesno" data-no-tap="true" role="group" aria-label={name}>
      <button
        type="button"
        className={`seg-btn${errCls}`}
        aria-pressed={isYes}
        onClick={() => onChange(true)}
        onKeyDown={(e) => {
          if (e.key === 'Enter') e.preventDefault()
        }}
      >
        Yes
      </button>
      <button
        type="button"
        className={`seg-btn${errCls}`}
        aria-pressed={isNo}
        onClick={() => onChange(false)}
        onKeyDown={(e) => {
          if (e.key === 'Enter') e.preventDefault()
        }}
      >
        No
      </button>
    </div>
  )
}
